import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../auth/AuthContext";
import { useAuthedFetch } from "../auth/apiClient";

export interface BackupAppointment {
  work_order_ref: string;
  route_id: number;
  route_name: string;
  scheduled_at: string;
  ends_at?: string | null;
  date: string;
  customer_name: string | null;
  phone: string | null;
  email: string | null;
  address: string | null;
  scope: string | null;
  status: string | null;
  quote: { id: string; total: number | null; status: string | null; details: string | null } | null;
}

export type BackupSchedule = {
  ready: false;
  reason: string;
} | {
  ready: true;
  captured_at: string;
  coverage_start: string;
  coverage_end: string;
  timezone: string;
  stale: boolean;
  age_minutes: number;
  routes: { route_id: number; name: string; type: string }[];
  appointments: BackupAppointment[];
};

export function useBackupSchedule() {
  const fetchAuthed = useAuthedFetch();
  const { user, hasRole } = useAuth();
  return useQuery({
    queryKey: ["backup-schedule", user?.tenant_id, user?.id],
    enabled: hasRole("owner", "gm", "sales"),
    queryFn: async ({ signal }): Promise<BackupSchedule> => {
      const response = await fetchAuthed("/api/cockpit/schedule/backup", { signal, cache: "no-store" });
      if (!response.ok) throw new Error("Backup schedule could not load");
      return response.json() as Promise<BackupSchedule>;
    },
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
  });
}
